(function () {
  'use strict';

  var bannerId = 'shopify-pc__banner';
  var root = document.documentElement;
  var activeBanner = null;
  var resizeObserver = null;
  var mutationObserver = null;
  var bannerMutationObserver = null;
  var frame = 0;
  var preferenceGap = null;

  function removeClearance() {
    root.classList.remove('impact-cookie-banner-visible');
    root.style.removeProperty('--impact-cookie-banner-height');
  }

  function unbindBanner() {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
    if (bannerMutationObserver) {
      bannerMutationObserver.disconnect();
      bannerMutationObserver = null;
    }
    if (activeBanner) {
      activeBanner.classList.remove('impact-cookie-banner-ready');
    }
    activeBanner = null;
    preferenceGap = null;
  }

  function hasExpectedMarkup(banner) {
    return Boolean(
      banner.querySelector('.shopify-pc__banner__wrapper')
      && banner.querySelector('.shopify-pc__banner__body')
      && banner.querySelector('#shopify-pc__banner__btn-manage-prefs')
      && banner.querySelector('#shopify-pc__banner__btn-accept')
      && banner.querySelector('#shopify-pc__banner__btn-decline')
    );
  }

  function placePreferences(banner) {
    var paragraph = banner.querySelector('.shopify-pc__banner__body p');
    var controls = banner.querySelector('.shopify-pc__banner__btns');
    var manage = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (!paragraph || !controls || !manage) return;
    var compact = window.innerWidth <= 400;
    var lead = paragraph.firstChild;
    if (lead && lead.nodeType === 3) {
      if (!paragraph.hasAttribute('data-impact-original-copy')) paragraph.setAttribute('data-impact-original-copy', lead.data);
      var copy = compact ? 'Optional cookies: personalisation, ads and analytics. ' : paragraph.getAttribute('data-impact-original-copy');
      if (lead.data !== copy) lead.data = copy;
    }
    if (compact) {
      if (!preferenceGap) preferenceGap = document.createTextNode(' ');
      if (preferenceGap.parentNode !== paragraph) paragraph.appendChild(preferenceGap);
    } else if (preferenceGap && preferenceGap.parentNode) {
      preferenceGap.parentNode.removeChild(preferenceGap);
    }
    var target = compact ? paragraph : controls;
    if (manage.parentNode !== target) target.appendChild(manage);
  }

  function bindBanner(banner) {
    unbindBanner();
    activeBanner = banner;
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(scheduleMeasure);
      resizeObserver.observe(banner);
    }
    bannerMutationObserver = new MutationObserver(scheduleMeasure);
    bannerMutationObserver.observe(banner, { childList: true, subtree: true });
  }

  function measure() {
    frame = 0;
    var banner = document.getElementById(bannerId);

    if (!banner || !document.body.contains(banner)) {
      unbindBanner();
      removeClearance();
      return;
    }

    if (banner !== activeBanner) {
      bindBanner(banner);
    }

    if (!hasExpectedMarkup(banner)) {
      banner.classList.remove('impact-cookie-banner-ready');
      removeClearance();
      return;
    }

    if (!banner.hasAttribute('aria-label') && !banner.hasAttribute('aria-labelledby') && document.getElementById('shopify-pc__banner__body-title')) {
      banner.setAttribute('aria-labelledby', 'shopify-pc__banner__body-title');
    }
    placePreferences(banner);
    banner.classList.add('impact-cookie-banner-ready');

    var styles = window.getComputedStyle(banner);
    var height = styles.display === 'none' || styles.visibility === 'hidden'
      ? 0
      : Math.ceil(banner.getBoundingClientRect().height);

    if (height > 0) {
      root.style.setProperty('--impact-cookie-banner-height', height + 'px');
      root.classList.add('impact-cookie-banner-visible');
    } else {
      removeClearance();
    }
  }

  function scheduleMeasure() {
    if (!frame) {
      frame = window.requestAnimationFrame(measure);
    }
  }

  function start() {
    measure();
    mutationObserver = new MutationObserver(scheduleMeasure);
    mutationObserver.observe(document.body, { childList: true });
    window.addEventListener('resize', scheduleMeasure, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
